import { ReactElement, ReactNode } from 'react';

interface ContentLoadingProps {
  children?: ReactNode;
}

const CenteredContent = (props: ContentLoadingProps): ReactElement => {
  const { children } = props;

  return (
    <div className="full-height-width content-center">
      <div
        style={{ display: 'flex' }}
        className="ion-align-self-center ion-align-items-center"
      >
        {children}
      </div>
    </div>
  );
};

export { CenteredContent };
